export const Bio = {
  name: "Majd Yaqub",
  roles: [
    "Full Stack Developer",
    "Problem Solver",
    "IoT Programmer",
    "UI/UX Designer",
  ],
  description:
    `Full Stack Developer specialized in crafting efficient,
    high-performance web applications with focus on seamless scalability. 
    My expertise spans both front-end and back-end development, 
    ensuring solutions that meet current needs and effortlessly scale for future demands.`,
  github: `https://github.com/majdya`,
  resume: "",
  linkedin: "https://www.linkedin.com/in/majdya/",
  // twitter: "",
  // insta: "",
  // facebook: "",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "React Native",
        image:
          "https://w7.pngwing.com/pngs/574/164/png-transparent-react-computer-icons-redux-javascript-others-symmetry-electron-redux-thumbnail.png",
      },
      {
        name: "Redux",
        image:
          "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Material UI",
        image:
          "https://v4.mui.com/static/logo_raw.svg",
      },
      {
        name: "Tailwinds",
        image:
          "https://tailwindcss.com/_next/static/media/tailwindcss-mark.3c5441fc7a190fb1800d4a5c7f07ba4b1345a9c8.svg",
      },
      {
        name: "Flutter",
        image:
          "https://cdn-images-1.medium.com/max/1200/1*5-aoK8IBmXve5whBQM90GA.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "Grafana",
        image:
          "https://cdn.icon-icons.com/icons2/2699/PNG/512/grafana_logo_icon_171048.png",
      },
      {
        name: "Angular",
        image:
          "https://opensource.google/static/images/projects/os-projects-angular.svg",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://p1.hiclipart.com/preview/885/534/395/green-grass-nodejs-javascript-react-mean-angularjs-logo-symbol-png-clipart.jpg",
      },
      {
        name: "Express Js",
        image:
          "https://e7.pngegg.com/pngimages/247/558/png-clipart-node-js-javascript-express-js-npm-react-github-angle-text.png",
      },
      {
        name: "Fastify",
        image:
          "https://pbs.twimg.com/profile_images/970652657231847424/mWKpZoM4_400x400.jpg",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        name: "Influxdb",
        image:
          "data:image/png;base64,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",
      },
      {
        name: "Redis",
        image: "data:image/png;base64,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",
      },
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "Postgresql",
        image: "https://www.postgresql.org/media/img/about/press/elephant.png",
      },
    ],
  },
  {
    title: "Platforms",
    skills: [
      {
        name: "Azure",
        image: 'https://cdn.icon-icons.com/icons2/2699/PNG/512/microsoft_azure_logo_icon_170956.png',
      },
      {
        name: "Docker",
        image: 'https://cdn4.iconfinder.com/data/icons/logos-and-brands/512/97_Docker_logo_logos-512.png',
      },
      {
        name: "Linux",
        image: 'https://1000logos.net/wp-content/uploads/2017/03/LINUX-LOGO.png',
      },
      {
        name: "Windows",
        image: 'https://upload.wikimedia.org/wikipedia/commons/thumb/5/5f/Windows_logo_-_2012.svg/2048px-Windows_logo_-_2012.svg.png',
      },
      {
        name: "IBM",
        image: "https://i.pinimg.com/originals/b0/b1/8b/b0b18bd010c5851b5f82d0a98bfde369.png",
      },
      {
        name: "AWS",
        image: "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5c/AWS_Simple_Icons_AWS_Cloud.svg/1024px-AWS_Simple_Icons_AWS_Cloud.svg.png",
      },
      {
        name: "Firebase",
        image: "https://w7.pngwing.com/pngs/246/288/png-transparent-firebase-hd-logo-thumbnail.png",
      },

    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "https://camo.githubusercontent.com/fbfcb9e3dc648adc93bef37c718db16c52f617ad055a26de6dc3c21865c3321d/68747470733a2f2f7777772e766563746f726c6f676f2e7a6f6e652f6c6f676f732f6769742d73636d2f6769742d73636d2d69636f6e2e737667",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Bitbucket",
        image:
          "https://w7.pngwing.com/pngs/404/31/png-transparent-bitbucket-icon-hd-logo-thumbnail.png",
      },
      {
        name: "Jira",
        image:
          "https://i.pngimg.me/thumb/f/720/m2i8A0N4b1Z5d3m2.jpg",
      },
      {
        name: "Confluence",
        image:
          "https://seeklogo.com/images/C/confluence-logo-D9B07137C2-seeklogo.com.png",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Postman",
        image:
          "https://camo.githubusercontent.com/93b32389bf746009ca2370de7fe06c3b5146f4c99d99df65994f9ced0ba41685/68747470733a2f2f7777772e766563746f726c6f676f2e7a6f6e652f6c6f676f732f676574706f73746d616e2f676574706f73746d616e2d69636f6e2e737667",
      },
      {
        name: "WireGuard",
        image:
          "https://www.logo.wine/a/logo/WireGuard/WireGuard-Icon-Logo.wine.svg",
      },
      {
        name: "Figma",
        image:
          "https://camo.githubusercontent.com/ed93c2b000a76ceaad1503e7eb9356591b885227e82a36a005b9d3498b303ba5/68747470733a2f2f7777772e766563746f726c6f676f2e7a6f6e652f6c6f676f732f6669676d612f6669676d612d69636f6e2e737667",
      },
      {
        name: "Bitbuckit pipelines",
        image:
          "https://www.freshleafmedia.co.uk/assets/media/bitbucket-pipeline_blogThumb.png",
      },
      {
        name: "Azure Devops",
        image:
          "https://seeklogo.com/images/A/azure-devops-logo-E7364216A7-seeklogo.com.png",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://feelit.tech/wp-content/uploads/2023/06/Favicon-19.png",
    role: "IoT Full-Stack Developer",
    company: "Feelit Technologies Ltd.",
    date: "Aug 2019 - Oct 2023",
    desc: "Building E2E & scaling solution to connect & visualize sensors installed at clients sites to Feelit cloud System",
    skills: [
      "Azure Functions",
      "Azure Event-Hub",
      "Redis",
      "NodeJS",
      "JavaScript",
      "React Js",
      "Linux",
      "Bluetooth",
      "InfluxDB",
      "WireGuard",
      "MongoDB",
      "Angular",
      ".Net",
      "Flutter",
      "Authentication",
      "Docker",
      "Docker-compose",
      "Terraform",
      "IBM Cloud",
      "AWS",
      "Grafana"
    ],
    doc: "",
  },
  {
    id: 1,
    img: "https://media.licdn.com/dms/image/D4D1BAQEpf_EYtyJMvQ/company-background_10000/0/1657803946285/kavmashve_cover?e=2147483647&v=beta&t=webY57Wbd_fuD4AAQomk_odSY4qzbvWF2gyUD1xMUWc",
    role: "Javascript Full-Stack Mentor",
    company: "Kav-Mashve",
    date: "April 2022 - March 2023",
    desc: "Teaching & Mentoring collage students to gain and develop skills in the industry as full stack javascript developers ",
    skills: [
      "HTML",
      "CSS",
      "JavaScript",
      "NodeJs",
      "CI/CD",
      "TDD(test driven development)",
      "Jest",
      "Mocha",
      "ReactJS",
      "Figma",
      "MongoDB",
      "PostgreSql",
      "Mentoring & communication skills",
      "Mentoring",
    ],
  },
  {
    id: 2,
    img: "https://images.crunchbase.com/image/upload/c_lpad,f_auto,q_auto:eco,dpr_1/tyjk2y005j0jidzcu21b",
    role: "QA Automation Developer",
    company: "Shield34",
    date: "Apr 2018 - Dec 2019",
    desc: "Design test cases, build automation for these scenarios & manage the life-cycle of the bugs in the system",
    skills: [
      "Java",
      "Selenium",
      "Angular",
      "Python",
      "CI/CD",
    ],
  },
  {
    id: 3,
    img: "https://logowik.com/content/uploads/images/hola-vpn8602.jpg",
    role: "Open Source Contributor ",
    company: "Hola VPN",
    date: "Aug 2017 - Nov 2017",
    desc: "Monitoring traffic loads on servers, testing new features released",
    skills: [
      "Linux",
      "Bash",
      "NodeJs",
      "Jira",
      "HTML",
      "CSS",
      "JavaScript",
      "VirtualBox",
      "Windows",
    ],
    doc: "",
  },
];

export const education = [
  // {
  //   id: 0,
  //   img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/Kiit.jpeg?alt=media&token=3839d520-c59d-4341-ad8f-0980c98de4dd",
  //   school: "Kalinga Institute of Industrial Technology, Bhubaneswar",
  //   date: "Oct 2021 - Sep 2025",
  //   grade: "8.71 CGPA",
  //   desc: "I am currently pursuing a Bachelor's degree in Computer Science and Engineering at Kalinga Institute of Industrial Technology, Bhubaneswar. I have completed 4 semesters and have a CGPA of 8.71. I have taken courses in Data Structures, Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, and Computer Networks, among others. I am also a member of the Google Developers Student Club (GDSC) at KIIT, where I am learning and working on exciting projects with a team of talented developers.",
  //   degree: "Bachelor of Technology - BTech, Computer Science and Engineering",
  // },
];

export const projects = [

  {
    id: 0,
    title: "",
    date: "",
    description:
      "",
    image:
      "",
    tags: [],
    category: "",
    github: "",
    webapp: "",
    member: [
      {
        name: "",
        img: "",
        linkedin: "",
        github: "",
      },
    ],
  },

];

export const TimeLineData = [
  { year: 2017, text: "Started my journey" },
  { year: 2018, text: "Worked as a freelance developer" },
  { year: 2019, text: "Founded JavaScript Mastery" },
  { year: 2020, text: "Shared my projects with the world" },
  { year: 2021, text: "Started my own platform" },
];
